export default __webpack_public_path__ + "alberta-shoppingcart-full-abo.63f583d26b770ce02127.svg";